<!-- certificate-value-editor.component.html -->
<div class="certificate-value-editor-container">
    <h3>Zertifikatsdaten ausfüllen</h3>
    <p>Bitte füllen Sie die Werte für die definierten Attribute ein.</p>

    <div class="value-root-list">
        @for (tmpl of templateNodes; track tmpl.id || $index) {
            <app-template-value-node-editor [templateNode]="tmpl"
                [valueNode]="valueNodes[$index]" (valueChange)="onValueTreeChange()">
            </app-template-value-node-editor>
        }
    </div>
</div>